import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {FromShipping, Shipping} from '../models/shipping';

export const shippingUpdateActionTypes = {
  UPDATE: type('[shipping] Update'),
  UPDATE_SUCCESS: type('[shipping] Update Success'),
  UPDATE_FAIL: type('[shipping] Update Fail'),
};

export class UpdateShippingAction implements Action {
  readonly type = shippingUpdateActionTypes.UPDATE;
  constructor(public payload?:  FromShipping) {}
}

export class UpdateShippingSuccessAction implements Action {
  readonly type = shippingUpdateActionTypes.UPDATE_SUCCESS;
  constructor(public payload?: Shipping) {}
}

export class UpdateShippingFailAction implements Action {
  readonly type = shippingUpdateActionTypes.UPDATE_FAIL;
  constructor(public payload?: string) {}
}
